import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16c22984"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cancel-meeting" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "d-flex align-items-center justify-content-between mb-0 fw-bold cancel-event-header bg-white font-size-lg" }, " Cancel Event ", -1 /* HOISTED */))
const _hoisted_3 = {
  key: 0,
  class: "d-flex align-items-center cancel-warning my-2 mx-3 font-size-xs"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-secondary ms-2 me-2" }, null, -1 /* HOISTED */))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "You're cancelling this event in the series", -1 /* HOISTED */))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "px-3 pb-2 mt-2 font-size-sm" }, "Cancel this event and notify all participants.", -1 /* HOISTED */))
const _hoisted_8 = { class: "px-3" }
const _hoisted_9 = { class: "d-flex justify-content-end p-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.isRecurringEvent)
      ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
          _hoisted_4,
          (_ctx.isCancelSeries)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, "You're cancelling this and all the following events in this series."))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_6,
                _createElementVNode("button", {
                  type: "button",
                  class: "cancel-series-btn fw-semibold ms-auto bg-white",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isCancelSeries = true))
                }, " Cancel entire series ")
              ], 64 /* STABLE_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, [
      _withDirectives(_createElementVNode("textarea", {
        class: "form-control",
        rows: "4",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.optionalMessage) = $event)),
        placeholder: "Type your message here (Optional)"
      }, null, 512 /* NEED_PATCH */), [
        [_vModelText, _ctx.optionalMessage]
      ])
    ]),
    _createElementVNode("footer", _hoisted_9, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-light border border-secondary me-2 bg-white",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cancel()))
      }, " Dismiss "),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-danger",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.submit()))
      }, "Cancel")
    ])
  ]))
}